import { render } from "./title.vue?vue&type=template&id=10a9cfae&scoped=true"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"

import "./article.less?vue&type=style&index=0&lang=less"
import "./title.vue?vue&type=style&index=1&id=10a9cfae&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a9cfae"]])

export default __exports__